import {useContext} from "react";
import {GlobalContext} from "../utils/context";

const tiers = ["Free", "Basic", "Business", "Admin"]

const UserTable = ({selectedUser, setSelectedUser}) => {
	const {users} = useContext(GlobalContext);
	const onUserChangeTier = (id, tier) => {
		window.reqServer("/admin/user/tier", "put", {id, tier: (tier+1)%tiers.length});
	}

	return <div className="table-container">
		<table>
			<thead>
				<tr>
					<td>Email</td>
					<td>Managers</td>
					<td>Tier</td>
					<td></td>
				</tr>
			</thead>
			<tbody>
			{
				users.map((user) => {
					const selected = selectedUser===user._id;
					return <tr
						key={user._id} onClick={()=>setSelectedUser(selected?null:user._id)}
						className={selected ? 'selected-tr' : ''}
					>
						<td>{user.email}</td>
						<td>{user.managers}</td>
						<td>
							{tiers[user.tier||0]}
						</td>
						<td>
							<button
								className="btn1" style={{marginLeft: 20, fontSize: 12}}
								onClick={(e)=>{e.stopPropagation();onUserChangeTier(user._id, user.tier)}}
							><span>Chagne</span></button>
						</td>
					</tr>
				})
			}
			</tbody>
		</table>
	</div>
}

export default UserTable;